export default "__VITE_ASSET__DAcwJCQy__"